
import { Component, Vue, Watch } from "vue-property-decorator";
import CatalogoResponse from "@/models/CatalogoResponse";
import AfiliadoService from "@/services/AfiliadoService";
import SobrevivenciaService from "@/services/SobrevivenciaService";
import Banco from "@/models/Banco";
import FormaDePago from "@/models/FormaDePago";
import RegistroPresolicitud from "@/models/RegistroPresolicitud";
import { AxiosResponse } from "axios";
import ServiceResponseSolicitud from "@/services/response-models/ServiceResponseSolicitud";
import { Action, Getter } from "vuex-class";
import User from "@/models/User";
import ValidationService from "@/services/ValidationService";
import ValidacionCedulaIt, {
  ValidacionCedulaItResp,
} from "@/models/ValidacionCedulaIt";
import Esigner from "@/models/Esigner";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import CustomFileInput from "@/components/CustomFileInput.vue";
import IngresoTardioService from "@/services/IngresoTardioService";
import CesantiaService from "@/services/CesantiaService";
import {
  ParametrosValidacionRequisitosBeneficio,
  Requisito,
} from "@/models/RequisitoBeneficio";
import FirmanteContratoIngresoTardio from "@/models/FirmanteContratoIngresoTardio";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import Presolicitud from "@/models/Presolicitud";
import ServiceResponseArchivos from "@/services/response-models/ServiceResponseArchivos";
import DocumentoPresolicitud from "@/models/DocumentoPresolicitud";
import ServiceResponseEntities from "@/services/response-models/ServiceResponseEntities";
import { formatFechaAfpSiembra, formatCedula } from "@/utils/HelperFunctions";
import Swal, { SweetAlertResult } from "sweetalert2";
import Inputmask from "inputmask";
import VueFormWizard from "@/vue-form-wizard/types/VueFormWizard";
import PackageResult from "@/models/PackageResult";
import VueFormWizardButton from "@/vue-form-wizard/types/VueFormWizardButton";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import FormaGeneraSolicitudEnum from "@/enums/FormaGeneraSolicitudEnum";
import ValidacionCertificacionTss from "@/models/ValidacionCertificacionTss";
import FileConfig from "../../FileConfig";
import RegistroFallecimiento from "@/components/sobrevivencia/RegistroFallecimiento.vue";
import SubirDocumentacion from "@/components/sobrevivencia/SubirDocumentacion.vue";
import Validacion from "@/components/sobrevivencia/Validacion.vue";
import ValidacionAseguradora from "@/components/sobrevivencia/ValidacionAseguradora.vue";
import Formulario from "@/components/sobrevivencia/Formulario.vue";
import MetodoPago from "@/components/sobrevivencia/MetodoPago.vue";
import Firma from "@/components/sobrevivencia/Firma.vue";
import Resumen from "@/components/sobrevivencia/Resumen.vue";
import { DocTypeCodesEnum } from "@/enums/DocTypeCodesEnum";
import ConsultaFallecido, {
  ConsultaValidacionBeneficiarioResp,
} from "@/models/ConsultaFallecido";
import { extend } from "vee-validate";
import Benefactor from "@/models/Sobrevivencia/Benefactor";
import BenefactorDocument from "@/models/Sobrevivencia/BenefactorDocument";
import { PossibleStates } from "@/enums/PossibleStates";
import DatosBeneficiario from "@/components/sobrevivencia/DatosBeneficiario.vue";
import CodTipoDocumento from "@/enums/CodTipoDocumento";
import EstadoAseguradora from "@/enums/EstadoAseguradora";
import FormularioRespuesta from "@/models/Sobrevivencia/Formulario/FormularioRespuesta";
import SaveFormularioRequest from "@/models/Sobrevivencia/Formulario/SaveFormularioRequest";
import BaseSobrevivenciaRequest from "@/models/Sobrevivencia/BaseSobrevivenciaRequest";
import EtapaRequest from "@/models/Sobrevivencia/SobrevivenciaPresolicitud/EtapaRequest";
import { is } from "vee-validate/dist/rules";
import store from "@/store";
import FirmaDescargoRequest from "@/models/Sobrevivencia/Firma/FirmaDescargoRequest";
import NoLoggedUser from "@/models/Sobrevivencia/NoLoggedUser/NoLoggedUser";
import { sanitizeFileName } from "@/utils/SanitizeFileName";

Vue.directive("input-mask", {
  update: function (el: any, binding: any, vnode: any) {
    const mascara: string = vnode.data.attrs.mask;
    const im = new Inputmask(mascara);
    im.mask(el);
  },
});

extend("mask", {
  validate: (value: string, params) => {
    var inputContains_ = value.indexOf("_") > -1;
    return !inputContains_;
  },
  params: [{ name: "mask" }],
  message: "El número de cuenta es inválido.",
});

class FormWizardStep {
  public tabIndex: number;
  public formWizardChildrenIndex: number;
}

@Component({
  components: {
    CustomFileInput,
    RegistroFallecimiento,
    Formulario,
    SubirDocumentacion,
    Validacion,
    ValidacionAseguradora,
    Firma,
    MetodoPago,
    Resumen,
    DatosBeneficiario,
  },
})
export default class RegistroSobrevivencia extends Vue {
  ///
  public loadingPage: boolean = false;
  public openBeneficiarioId: number = 0;
  public beneficiarioFormKey: number = 99;
  public generalFormKey: number = 9999;
  public etapa: number = 0;
  public isFormGeneralValid = false;
  public isFormBeneficiariosValid = false;
  public isAnyDocPending = false;
  public jumpTo: number = null;
  @Getter("currentBenefactor") currentBenefactor: Benefactor;
  @Getter("validateAllSobrevivencia") validateAllSobrevivencia: boolean;
  @Getter("noLoggedUser") noLoggedUser: NoLoggedUser;
  @Getter("cedulaFallecido") cedulaFallecido: string;
  /// triggers//
  public triggerRegisterFirstStep: boolean = false;
  public triggerFormularioCollection: boolean = false;
  public triggerGeneralFormularioCollection: boolean = false;
  public triggerBeneficiarioFormularioCollection: boolean = false;
  ////
  public registroPresolicitud: RegistroPresolicitud =
    new RegistroPresolicitud();
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public validationService: ValidationService = new ValidationService();
  public sobrevivenciaService: SobrevivenciaService =
    new SobrevivenciaService();
  public ingresoTardioService: IngresoTardioService =
    new IngresoTardioService();
  public cesantiaService: CesantiaService = new CesantiaService();
  public fileConfig: FileConfig;
  //
  public showBeneficiariosInnerTab: boolean = false;
  //#region Cédula
  public cedulaFrontalServerMessage: string = "";
  public cedulaTraseraServerMessage: string = "";
  public cedulaFrontalFiles: Array<File> = [];
  public cedulaTraseraFiles: Array<File> = [];
  public inputCedulaFrontalIsValid: boolean = false;
  public inputCedulaTraseraIsValid: boolean = false;
  //#endregion
  //#region Documento
  public documentoServerMessage: string = "";
  public documentoFiles: Array<File> = [];
  //#endregion
  //#region Referencia Documento Bancario
  public referenciaDocumentoBancarioFiles: Array<File> = [];
  public showReferenciaDocumentoBancarioFilesRequiredError: boolean = false;
  public showInvalidReferenciaDocumentoBancarioFilesTypeError: boolean = false;
  public showInvalidReferenciaDocumentoBancarioFilesSizeError: boolean = false;
  public showReferenciaDocumentoBancarioServerValidationMessage: boolean =
    false;
  public referenciaDocumentoBancarioFilesRequiredMessage: string =
    "La referencia de documento bancario es requerida.";
  public referenciaDocumentoBancarioServerValidationMessage: string = "";
  public inputReferenciaDocumentoBancarioIsValid: boolean = false;

  //#endregion
  //#region Documentos Adicionales
  public documentoAdicionalFiles: Array<Array<File>> = [];
  public showDocumentoAdicionalFilesRequiredError: Array<boolean> = [];
  public showInvalidDocumentoAdicionalFilesTypeError: Array<boolean> = [];
  public showInvalidDocumentoAdicionalFilesSizeError: Array<boolean> = [];
  public documentoAdicionalFilesRequiredMessage: string =
    "El documento adicional es requerido";
  //#endregion
  public triggerInputValidations = false;
  public formWizardButtons: Array<
    Array<VueFormWizardButton<RegistroSobrevivencia>>
  > = [];
  public formWizardSteps: {
    firstStep: FormWizardStep;
    secondStep: FormWizardStep;
    thirdStep: FormWizardStep;
    fourthStep: FormWizardStep;
    fifthStep: FormWizardStep;
    sixthStep: FormWizardStep;
    seventhStep: FormWizardStep;
    eighthStep: FormWizardStep;
    // ninthStep: FormWizardStep;
  } = {
    firstStep: {
      tabIndex: 0,
      formWizardChildrenIndex: 8,
    },
    secondStep: {
      tabIndex: 1,
      formWizardChildrenIndex: 9,
    },
    thirdStep: {
      tabIndex: 2,
      formWizardChildrenIndex: 10,
    },
    fourthStep: {
      tabIndex: 3,
      formWizardChildrenIndex: 11,
    },
    fifthStep: {
      tabIndex: 4,
      formWizardChildrenIndex: 12,
    },
    sixthStep: {
      tabIndex: 5,
      formWizardChildrenIndex: 13,
    },
    seventhStep: {
      tabIndex: 6,
      formWizardChildrenIndex: 14,
    },
    eighthStep: {
      tabIndex: 7,
      formWizardChildrenIndex: 15,
    },
    // ninthStep: {
    //   tabIndex: 8,
    //   formWizardChildrenIndex: 17,
    // },
  };
  public isValidationValid: boolean = false;
  public tiposDocumentoByDocumento: {
    tipoDocumentoCedula: string;
    tipoDocumentoDocumento: Array<string>;
    tipoDocumentoReferenciaDocumentoBancario: string;
    tipoDocumentoDocumentosAdicionales: Array<Array<string>>;
  } = {
    tipoDocumentoCedula: null,
    tipoDocumentoDocumento: [],
    tipoDocumentoReferenciaDocumentoBancario: null,
    tipoDocumentoDocumentosAdicionales: [],
  };
  public cedulaIsValid: boolean = false;
  public documentoIsValid: boolean = false;
  public datosCedulaCoincideConBD: boolean = true;
  public resultValidacionCedula: ValidacionCedulaItResp = null;
  //#region Tipo de Documento
  public tiposDocumento: Array<Requisito> = [];
  public tiposDocumentoLoading: boolean = false;
  public tipoDocumento: Requisito = null;
  //#endregion
  //#region Select Vias Notificacion
  public viasNotificacion: Array<CatalogoResponse> = [];
  public viasNotificacionLoading: boolean = false;
  public viaNotificacion: CatalogoResponse = null;
  //#endregion
  //#region Metodo de Pago
  public metodosDePago: Array<FormaDePago> = [];
  public metodosDePagoLoading: boolean = false;
  public metodoDePago: FormaDePago = null;
  //#endregion
  //#region Banco
  public bancos: Array<Banco> = [];
  public bancosLoading: boolean = false;
  public banco: Banco = null;
  //#endregion
  //#region Tipo de Cuenta
  public tiposDeCuenta: Array<CatalogoResponse> = [];
  public tiposDeCuentaLoading: boolean = false;
  public tipoDeCuenta: CatalogoResponse = null;
  //#endregion
  public validacionTssActualizadaDespues24hours = false;
  public numeroCuenta: string = null;
  @Getter("user") user: User;
  @Getter("validacionCertificacionTss")
  validacionCertificacionTss: ValidacionCertificacionTss;
  @Action("setUserLoggedAction") setUserLoggedAction;
  @Action("setValidacionCertificacionTssAction")
  setValidacionCertificacionTssAction;
  public loading: boolean = false;
  public numeroSolicitudCreada: number = null;
  public signUrlContrato: string = null;
  public sobrevivenciaWizard: VueFormWizard = null;
  public omitirActualizacionDatos: boolean = false;
  public modificaValorViaNotificacion: boolean = false;
  public valorViaNotificacion: string = null;
  public scrollHandledManually = false;

  //#region Edición
  public currentPresolicitud: Presolicitud = null;
  public documentosCurrentPresolicitud: DocumentoPresolicitud[] = [];
  public documentosAdicionales: DocumentoPresolicitud[] = [];
  public numeroSolicitud: number = null;
  public isEditing: boolean = false;
  public loadingFiles: boolean = false;
  public previousCedulaFrontalFiles: Array<DocumentoPresolicitud> = [];
  public previousCedulaTraseraFiles: Array<DocumentoPresolicitud> = [];
  public previousDocumentoFiles: Array<DocumentoPresolicitud> = [];
  public previousReferenciaDocumentoBancarioFiles: Array<DocumentoPresolicitud> =
    [];
  public previousDocumentoAdicionalFiles: Array<DocumentoPresolicitud> = [];
  public removedFiles: Array<DocumentoPresolicitud> = [];
  public benefactors: Benefactor[] = [];
  public generalDocs: BenefactorDocument[] = [];
  public estadoAseguradora: EstadoAseguradora = EstadoAseguradora.Declinada;

  public callInputValidation() {
    this.triggerInputValidations = !this.triggerInputValidations;
  }
  public created() {
    // if (this.user.esAfiInactivo)
    // {this.$router.push("/")};

    this.fileConfig = new FileConfig(5, [
      "image/jpeg",
      "image/jpg",
      "image/tiff",
      "image/png",
      "application/pdf",
    ]);
    window.addEventListener("beforeunload", this.beforeUnloadHandler);
  }

  public async mounted() {
    this.loadingPage = true;
    this.sobrevivenciaWizard = this.$refs.sobrevivenciaWizard as VueFormWizard;
    this.handleNoLoggedUser();
    await this.updateUser();
    if (this.$route.query.principal) {
      this.user.cedula = this.$route.query.principal.toString();
    }
    //  this.user.cedula = "4021370012";
    if (this.$route.query.numeroSolicitud || this.numeroSolicitud != null) {
      if (this.numeroSolicitud == null) {
        this.numeroSolicitud = Number(this.$route.query.numeroSolicitud);
      }
      this.isEditing = !!this.numeroSolicitud;
      if (this.isEditing) {
        this.showLoadingAlert(
          "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
        );
        this.currentPresolicitud = await this.getPresolicitud();
        if (this.currentPresolicitud == null) {
          this.$router.push("/home");
          Swal.close();
        }
        if (this.currentPresolicitud.solCancelada) {
          this.showLoadingConfirm("Esta solicitud ha sido cancelada.", () => {
            this.$router.push("/home");
            Swal.close();
          });
          return;
        }
        const currentDate: string = (
          await this.afiliadoService.getCurrentDate()
        ).data.currentDate;
        const hourDifference: number =
          Math.abs(
            new Date(currentDate).getTime() -
              new Date(this.currentPresolicitud.fechaSolicitud).getTime()
          ) /
          (60 * 60 * 1000);
        const hourDifferenceGreaterThan24: boolean = hourDifference >= 24;
        if (hourDifferenceGreaterThan24) {
          this.validacionTssActualizadaDespues24hours = true;
          // await this.validarTss();
        }
        this.documentosCurrentPresolicitud =
          await this.getDocumentosPresolicitud();
        Swal.close();
        //
        //Update UI values from server
        // this.datosCedulaCoincideConBD =
        //   this.currentPresolicitud.cedulaCoincide &&
        //   this.currentPresolicitud.nombreCoincide &&
        //   this.currentPresolicitud.fechaNacimientoCoincide;
        // this.resultValidacionCedula = new ValidacionCedulaItResp(
        //   this.currentPresolicitud.cedulaCoincide,
        //   this.currentPresolicitud.nombreCoincide,
        //   this.currentPresolicitud.fechaNacimientoCoincide
        // );
      }
    }
    ///verificar si hay documentos rechazados.
    //si estan rechazados la etapa cambia a 2 para volver a subir los documentos
    //si todo está aprobado la etapa cambia

    await this.getEtapaSolicitud();
    if (this.numeroSolicitud != null) {
      //ojo promise all aqui
      //  console.log("1_______________________________________________________________")
      await this.getBeneficiarios();
      // console.log("2_______________________________________________________________")
      await this.getDocumentosGenerales();
      // console.log("3_______________________________________________________________")
      await this.getDocumentosBeneficiarios();
      // console.log("4_______________________________________________________________")

      this.changeWizardTabFromEtapa();
      //  console.log("5_______________________________________________________________")
      this.validatePendingPresolicitud();
      //  console.log("6_______________________________________________________________")
      const solicitud = await this.afiliadoService.getSolicitud({
        numeroSolicitud: this.numeroSolicitud,
        tipoBeneficio: TipoBeneficioEnum.Fallecimiento,
      });
      //  console.log("7_______________________________________________________________")
      if (solicitud.data.entity.estadoAseguradora)
        this.estadoAseguradora = solicitud.data.entity.estadoAseguradora;
    }

    this.formWizardButtons = [
      [
        //Paso 1 Registro acta defunción
        {
          text: "Cancelar",

          action: () =>
            new Promise((resolve, reject) => {
              resolve(true);
            }),

          className:
            "mr-auto ml-0 siembra-orange-button big-button buttns-w-100",

          isLoadingButton: false,

          nextAction: (props: any, _this: RegistroSobrevivencia) => {
            this.navigateToSolicitudes();
          },

          display: () => true,
        },
        {
          text: "Siguiente",

          action: this.returnTrue,

          className: "ml-auto siembra-orange-button big-button buttns-w-100",

          isLoadingButton: true,

          nextAction: (props: any, _this?: RegistroSobrevivencia) => {
            this.registerFirstStep();
            this.scrollToTop();
          },

          display: () => true,
        },
      ],

      [
        // Paso 2 Formulario dinamico y form beneficiarios
        {
          text: "Anterior",

          action: () => {
            return new Promise(async (resolve, reject) => {
              return resolve(true);
            });
          },
          className:
            "mr-auto ml-0 siembra-orange-button big-button buttns-w-100",
          isLoadingButton: false,

          nextAction: (props: any, _this: RegistroSobrevivencia) => {
            if (this.showBeneficiariosInnerTab) {
              this.showBeneficiariosInnerTab = !this.showBeneficiariosInnerTab;
            } else {
              this.scrollToTop();
              props.prevTab();
            }

            _this.enableStep(
              _this.formWizardSteps.secondStep.formWizardChildrenIndex
            );
          },

          display: () => {
            this.scrollToTop();
            return this.showBeneficiariosInnerTab;
            // return true;
          },
        },

        {
          text: "Guardar",

          action: this.returnTrue,

          className:
            "mr-auto ml-auto  siembra-white-button big-button buttns-w-100 ",

          isLoadingButton: false,

          nextAction: async (props: any, _this: RegistroSobrevivencia) => {
            if (this.showBeneficiariosInnerTab) {
              await this.getBeneficiarioFormularioResponses();

              this.scrollToTop();
            } else {
              this.getGeneralFormularioResponses();

              this.scrollToTop();
            }
          },

          display: () => {
            this.scrollToTop();
            return this.showBeneficiariosInnerTab;
          },
        },
        {
          text: "Guardar",

          action: this.returnTrue,

          className:
            "mr-auto ml-0  siembra-white-button big-button buttns-w-100 ",

          isLoadingButton: false,

          nextAction: async (props: any, _this: RegistroSobrevivencia) => {
            if (this.showBeneficiariosInnerTab) {
              await this.getBeneficiarioFormularioResponses();
            } else {
              this.getGeneralFormularioResponses();
            }
          },

          display: () => {
            return !this.showBeneficiariosInnerTab;
          },
        },

        {
          text: "Siguiente",
          action: () =>
            new Promise(async (resolve, reject) => {
              this.$store.dispatch("setValidateAllSobrevivenciaAction", false);

              if (!this.showBeneficiariosInnerTab) {
                this.isFormGeneralValid = await this.ValidateFormGeneral();

                if (this.isFormGeneralValid) {
                  this.getGeneralFormularioResponses();
                } else {
                  await this.showErrorAlert(
                    "Para seguir con su solicitud es necesario que complete los campos requeridos."
                  );
                  this.scrollToTop();
                  return reject();
                }
              } else {
                this.isFormBeneficiariosValid =
                  await this.ValidateFormBeneficiarios();

                if (this.isFormBeneficiariosValid) {
                  this.getBeneficiarioFormularioResponses();
                  this.setEtapa(2);
                } else {
                  await this.showErrorAlert(
                    "Para seguir con su solicitud es necesario que complete los campos requeridos."
                  );
                  this.scrollToTop();
                  return reject();
                }
                resolve(true);
              }
              if (!this.showBeneficiariosInnerTab && this.isFormGeneralValid) {
                this.showBeneficiariosInnerTab =
                  !this.showBeneficiariosInnerTab;
                this.scrollToTop();
              } else if (
                this.showBeneficiariosInnerTab &&
                this.isFormBeneficiariosValid
              ) {
                this.$store.dispatch("setValidateAllSobrevivenciaAction", true);
                //  console.log("jump to ",this.jumpTo)
                if (this.jumpTo != null) {
                  this.setEtapa(this.jumpTo);
                  // console.log("jump to ",this.jumpTo)
                  //this.jumpTo = null;
                } else {
                  // console.log("NO JUMP",this.jumpTo)
                  this.changeWizardTab(1, 2);
                }
                this.scrollToTop();
              }

              resolve(true);
            }),

          className: "ml-auto  siembra-orange-button big-button buttns-w-100",

          isLoadingButton: false,

          nextAction: async (props: any, _this: RegistroSobrevivencia) => {
            _this.enableStep(
              _this.formWizardSteps.secondStep.formWizardChildrenIndex
            );
          },

          display: () => true,
        },
      ],
      //Paso 3 Subir documentación

      [
        {
          text: "Modificar cuestionario",

          action: () =>
            new Promise((resolve, reject) => {
              resolve(true);
            }),

          className: "mr-auto mt-4 siembra-blue-button big-button buttns-w-100",

          isLoadingButton: false,

          nextAction: (props: any, _this?: RegistroSobrevivencia) => {
            this.$store.dispatch("setValidateAllSobrevivenciaAction", false);
            props.prevTab();
            this.scrollToTop();
          },

          display: () => true,
        },
        {
          text: "Guardar",

          action: this.saveBeneficiarios,

          className:
            " mr-auto ml-auto siembra-white-button big-button buttns-w-100",

          isLoadingButton: false,

          nextAction: (props: any, _this: RegistroSobrevivencia) => {
            debugger;
            this.setEtapa(2);
            this.$store.dispatch("setValidateAllSobrevivencia", false);
            this.showSuccessAlert();
          },

          display: () => true,
        },
        {
          text: "Siguiente",

          action: () =>
            new Promise((resolve, reject) => {
              this.$store.dispatch("setValidateAllSobrevivenciaAction", true);
              resolve(true);
            }),

          className:
            "ml-auto mt-4 siembra-orange-button big-button buttns-w-100",

          isLoadingButton: true,

          nextAction: async (props: any, _this: RegistroSobrevivencia) => {
            this.$store.dispatch("setValidateAllSobrevivenciaAction", true);
            setTimeout(() => {}, 5000);
            // console.log("VALIDATE ALL : " ,this.validateAllSobrevivencia);
            //Se validan los formularios del paso 2 y se devuelve al tab si no son válidos
            var isBeneficiariosValid;
            var isGeneralValid;

            await Promise.all([
              this.getBeneficiarios(),
              this.getDocumentosGenerales(),
            ]);
            //  await this.getBeneficiarios();
            //  await this.getDocumentosGenerales();
            await this.getDocumentosBeneficiarios();
            this.ValidateFormGeneral().then((value: boolean) => {
              isGeneralValid = value;
              this.ValidateFormBeneficiarios()
                .then((value2: boolean) => {
                  isBeneficiariosValid = value2;

                  const areValid = this.isDocumentationValid();
                  // console.log("Validacion documentos" ,areValid);
                  if (areValid.missingFiles) {
                    return Swal.fire({
                      text: "Para continuar con tu solicitud es necesario que cargues todos los documentos requeridos.",
                      icon: "error",
                      showConfirmButton: true,

                      confirmButtonText: "Continuar",
                      allowOutsideClick: true,
                    });
                  } else if (areValid.rejectedFiles) {
                    return Swal.fire({
                      text: "Los archivos subidos no son válidos. Dirígete a 'Ver observaciones' para más información.",
                      icon: "error",
                      showConfirmButton: true,
                      confirmButtonText: "Continuar",
                      allowOutsideClick: true,
                    });
                  } else if (!isGeneralValid) {
                    Swal.fire({
                      text: "Para seguir con su solicitud es necesario que complete los campos requeridos.",
                      icon: "error",
                      showConfirmButton: true,
                      confirmButtonText: "Continuar",
                      allowOutsideClick: true,
                    });
                    (this.showBeneficiariosInnerTab = false), (this.jumpTo = 3);
                    this.changeWizardTab(2, 1);
                    this.scrollToTop();
                  } else if (!isBeneficiariosValid) {
                    Swal.fire({
                      text: "Para seguir con su solicitud es necesario que complete los campos requeridos.",
                      icon: "error",
                      showConfirmButton: true,
                      confirmButtonText: "Continuar",
                      allowOutsideClick: true,
                    });
                    (this.showBeneficiariosInnerTab = true),
                      this.changeWizardTab(2, 1);
                    this.jumpTo = 3;
                    this.scrollToTop();
                  } else if (isGeneralValid && isBeneficiariosValid) {
                    props.nextTab();
                    this.setEtapa(3);

                    this.scrollToTop();
                  }
                })
                .then(() => {
                  this.showBeneficiariosInnerTab = true;
                  this.scrollToTop();
                });
            });
          },

          display: () => true,
        },
      ],

      //Paso 4 Validación

      [
        {
          text: "Ir a mis solicitudes",

          action: this.navigateToSolicitudes,

          className: "ml-auto siembra-orange-button big-button buttns-w-100",

          isLoadingButton: false,

          display: () => {
            return !this.isValidationValid;
          },
        },
      ],
      //Paso 5 firma
      [
        {
          text: "Firmar",

          action: this.firmarContratoFallecimiento,

          className: "ml-auto siembra-orange-button big-button buttns-w-100",

          isLoadingButton: true,

          nextAction: (props: any, _this: RegistroSobrevivencia) => {
            // _this.sobrevivenciaWizard.changeTab(
            //   props.activeTabIndex,
            //   _this.formWizardSteps.sixthStep.tabIndex
            // );
          },

          display: () => true,
        },
      ],
      //Paso 6 Validación
      [
        {
          text: "Siguiente",

          action: () =>
            new Promise((resolve, reject) => {
              resolve(true);
            }),

          className:
            "ml-auto mt-4 siembra-orange-button big-button buttns-w-100",

          isLoadingButton: true,

          nextAction: (props: any, _this: RegistroSobrevivencia) => {
            props.nextTab();
          },

          display: () => {
            return this.currentBenefactor.indBiometrica == "S";
          },
        },
        {
          text: "Ir a mis solicitudes",

          action: this.navigateToSolicitudes,

          className: "ml-auto siembra-orange-button big-button buttns-w-100",

          isLoadingButton: false,

          display: () => {
            return (
              this.estadoAseguradora != null &&
              this.estadoAseguradora == "PENDIENTE"
            );
          },
        },
      ],
      //Paso 7 Método de pago
      [
        {
          text: "Anterior",

          action: () =>
            new Promise((resolve, reject) => {
              resolve(true);
            }),

          className: "mr-auto mt-4 siembra-gray-button big-button buttns-w-100",

          isLoadingButton: false,

          nextAction: (props: any, _this?: RegistroSobrevivencia) => {
            props.prevTab();
          },

          display: () => true,
        },

        {
          text: "Siguiente",

          action: () =>
            new Promise(async (resolve, reject) => {
              let isMetodoPagoValid = await this.ValidateMetodoPago();
              if (isMetodoPagoValid == true) {
                // this.saveBeneficiarios();
                // console.log("This. Current Benefactor en registro sobrevivencia antes de guardar",this.currentBenefactor)
                this.saveCurrentBenefactor();
                resolve(true);
              }
            }),

          className:
            "ml-auto mt-4 siembra-orange-button big-button buttns-w-100",

          isLoadingButton: true,

          nextAction: async (props: any, _this: RegistroSobrevivencia) => {
            let isMetodoPagoValid = await this.ValidateMetodoPago();
            if (isMetodoPagoValid) {
              props.nextTab();
            }
          },

          display: () => {
            return true;
          },
        },
      ],
      //Paso 8 firma
      [
        // {
        //   text: "Ir a mis solicitudes",

        //   action: this.navigateToSolicitudes,

        //   className: "ml-auto siembra-orange-button big-button",

        //   isLoadingButton: false,

        //   display: () => true,
        // },

        {
          text: "Firmar",

          action: this.firmarDescargoFallecimiento,

          className:
            "ml-auto mt-4 siembra-orange-button big-button buttns-w-100",

          isLoadingButton: true,

          nextAction: (props: any, _this: RegistroSobrevivencia) => {
            // props.nextTab();
          },

          display: () => true,
        },
      ],
      //Paso 9 resumen
      [
        {
          text: "Ir a mis solicitudes",

          action: this.navigateToSolicitudes,

          className: "ml-auto siembra-orange-button big-button buttns-w-100",

          isLoadingButton: false,

          display: () => true,
        },

        {
          text: "Siguiente",

          action: () =>
            new Promise((resolve, reject) => {
              resolve(true);
            }),

          className:
            "ml-auto mt-4 siembra-orange-button big-button buttns-w-100",

          isLoadingButton: true,

          nextAction: (props: any, _this: RegistroSobrevivencia) => {
            _this.sobrevivenciaWizard.changeTab(
              props.activeTabIndex,

              _this.formWizardSteps.fourthStep.tabIndex
            );

            _this.disableStep(
              _this.formWizardSteps.firstStep.formWizardChildrenIndex
            );

            _this.disableStep(
              _this.formWizardSteps.secondStep.formWizardChildrenIndex
            );

            _this.disableStep(
              _this.formWizardSteps.thirdStep.formWizardChildrenIndex
            );

            if (_this.generaSolicitudAutomatica) {
              props.nextTab();

              _this.disableStep(
                _this.formWizardSteps.fourthStep.formWizardChildrenIndex
              );
            }
          },

          display: () => true,
        },
      ],

      [
        {
          text: "Ir a mis solicitudes",

          action: this.navigateToSolicitudes,

          className: "ml-auto siembra-orange-button big-button buttns-w-100",

          isLoadingButton: false,

          display: () => true,
        },

        {
          text: "Siguiente",

          action: () =>
            new Promise((resolve, reject) => {
              resolve(true);
            }),

          className:
            "ml-auto mt-4 siembra-orange-button big-button buttns-w-100",

          isLoadingButton: true,

          nextAction: (props: any, _this: RegistroSobrevivencia) => {
            _this.sobrevivenciaWizard.changeTab(
              props.activeTabIndex,

              _this.formWizardSteps.fourthStep.tabIndex
            );

            _this.disableStep(
              _this.formWizardSteps.firstStep.formWizardChildrenIndex
            );

            _this.disableStep(
              _this.formWizardSteps.secondStep.formWizardChildrenIndex
            );

            _this.disableStep(
              _this.formWizardSteps.thirdStep.formWizardChildrenIndex
            );

            if (_this.generaSolicitudAutomatica) {
              props.nextTab();

              _this.disableStep(
                _this.formWizardSteps.fourthStep.formWizardChildrenIndex
              );
            }
          },

          display: () => true,
        },
      ],

      [
        {
          text: "Ir a mis solicitudes",

          action: this.navigateToSolicitudes,

          className: "ml-auto siembra-orange-button big-button buttns-w-100",

          isLoadingButton: false,

          display: () => true,
        },
      ],
    ];
    //  console.log("2_______________________________________________________________")
    //await this.getTiposDocumento();
    //await this.getViasNotificacion();
    //await this.getMetodosDePago();
    //await this.getBancos();
    //await this.getTiposDeCuenta();
    //await this.getTiposDocumentoByStep();

    this.loadingPage = false;

    this.$nextTick(() => {
      setTimeout(() => {
        this.scrollToTop();
      }, 300);
    });

    if (
      this.documentosCurrentPresolicitud &&
      this.documentosCurrentPresolicitud.length > 0
    ) {
      this.setPreviousFiles();
      //
      this.documentosAdicionales.forEach(
        (documentoAdicional: DocumentoPresolicitud) => {
          this.showDocumentoAdicionalFilesRequiredError.push(false);
          this.showInvalidDocumentoAdicionalFilesTypeError.push(false);
        }
      );
    }

    if (this.currentPresolicitud) {
      this.setFieldValues();

      if (this.currentPresolicitud.permiteFirma) {
        // this.setFieldValues();
        //  this.moveToFifthStepAndDisableTheRest();
        // Swal.close();
        // return;
      }

      // if (
      //   !this.existPreviousDocumentoFiles ||
      //   this.previousCedulaFrontalRequiereCambioDoc ||
      //   this.previousCedulaTraseraRequiereCambioDoc
      // ) {
      //   this.disableStep(
      //     this.formWizardSteps.secondStep.formWizardChildrenIndex
      //   );
      // }

      let currentStep: number = this.formWizardSteps.firstStep.tabIndex;

      // this.setCurrentStepBasedOnDocumentsThatRequireToBeChanged(currentStep);
    }

    Swal.close();
  }

  async getBeneficiarios() {
    const response = await this.sobrevivenciaService.GetBeneficiarios(
      "PortalBe",
      "0092873730",
      this.numeroSolicitud
    );

    this.benefactors = response.data.data;
  }

  async getDocumentosGenerales() {
    const response = await this.sobrevivenciaService.GetDocumentosBeneficiarios(
      this.numeroSolicitud,
      "PortalBe",
      "0092873730"
    );

    this.generalDocs = response.data.data;
  }

  async getDocumentosBeneficiarios() {
    const promises = this.benefactors.map(async (benefactor) => {
      const response =
        await this.sobrevivenciaService.GetDocumentosBeneficiarios(
          this.numeroSolicitud,
          "PortalBe",
          "0092873730",
          benefactor.idBeneficiario
        );

      response.data.data = response.data.data.map((document) => {
        document.codigoRuta = `${benefactor.numIdBeneficiario}/${document.codTipDocumento}`;

        return document;
      });

      benefactor.documents = response.data.data;

      return benefactor;
    });

    this.benefactors = await Promise.all(promises);
  }

  get fileInputRefDocumentoBancarioEsRequerido() {
    this.getDocumentosBeneficiarios();
    return (
      this.siEstaCreandoYEsTransferencia ||
      this.siIsEditYEsTransferenciaYDocRequiereCambioYNoTieneComprobante
    );
  }

  get siEstaCreandoYEsTransferencia() {
    return !this.isEditing && this.metodoDePagoIsTransferenciaBancaria;
  }

  get siIsEditYEsTransferenciaYDocRequiereCambioYNoTieneComprobante() {
    return (
      this.isEditing &&
      this.metodoDePagoIsTransferenciaBancaria &&
      this.previousReferenciaDocumentoBancarioRequiereCambioDoc &&
      !this.existReferenciaDocumentoBancarioFiles
    );
  }

  public beforeUnloadHandler(e) {
    e.preventDefault();
    // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    // Chrome requires returnValue to be set
    e.returnValue = "";
  }
  public removeFilesThatRequireChanges() {
    let cedulaFrontalThatRequireChange = this.previousCedulaFrontalFiles.filter(
      (x) => x.requiereCambioDoc
    )[0];
    let cedulaTraseraThatRequireChange = this.previousCedulaTraseraFiles.filter(
      (x) => x.requiereCambioDoc
    )[0];
    if (cedulaFrontalThatRequireChange || cedulaTraseraThatRequireChange) {
      this.removeCedulaFrontalFile(this.previousCedulaFrontalFiles[0]);
      this.removeCedulaTraseraFile(this.previousCedulaTraseraFiles[0]);
    }
    //
    let previousDocumentoFilesThatRequireChange =
      this.previousDocumentoFiles.filter((x) => x.requiereCambioDoc);
    previousDocumentoFilesThatRequireChange.forEach((doc) => {
      this.removeDocumentoFile(doc);
    });

    let previousReferenciaDocumentoBancarioFilesThatRequireChange =
      this.previousReferenciaDocumentoBancarioFiles.filter(
        (x) => x.requiereCambioDoc
      );
    previousReferenciaDocumentoBancarioFilesThatRequireChange.forEach((doc) => {
      this.removeReferenciaDocumentoBancarioFile(doc);
    });
    //
    let previousDocumentoAdicionalFilesThatRequireChange =
      this.previousDocumentoAdicionalFiles.filter((x) => x.requiereCambioDoc);
    previousDocumentoAdicionalFilesThatRequireChange.forEach((doc) => {
      this.removeDocumentoAdicionalFile(doc);
    });
  }

  public async updateUser(): Promise<void> {
    return new Promise((resolve, reject) => {
      const consultaFallecido = new ConsultaFallecido();
      consultaFallecido.cedulaBeneficiario = this.user.cedula;
      this.afiliadoService
        .consultarBeneficiario(consultaFallecido)
        .then(
          (
            response: AxiosResponse<
              ServiceResponseEntity<ConsultaValidacionBeneficiarioResp>
            >
          ) => {
            const consultaValidacionBeneficiarioResp = response.data.entity;
            this.user.correoElectronico1 =
              consultaValidacionBeneficiarioResp.email1;
            this.user.correoElectronico2 =
              consultaValidacionBeneficiarioResp.email2;
            this.user.celular = consultaValidacionBeneficiarioResp.celular;
            this.setUserLoggedAction(this.user);
            resolve();
          }
        )
        .catch(() => {
          reject();
        });
    });
  }

  @Watch("tipoDocumento")
  public onTipoDocumentoChangeInStep2(
    newValue: string,
    oldValue: string
  ): void {
    //Cuando el tipo documentoCambie si estamos en ediion hay que resetear el fileInput
    //Esto lo hacemos solo cuando esta editando, porque cuando esta creando si cambia de tipo
    //Documento no hay que resetear el fileInput
    if (this.isEditing && oldValue != null) {
      //Se evalua que all value no sea nulo para que en el first load del edit no modifique esto
      this.resetSecondStep(false);
      this.previousDocumentoFiles.splice(0, this.previousDocumentoFiles.length);
    }
  }
  @Watch("banco")
  public onBancoSelected(newValue: Banco, oldValue: Banco): void {
    if (!!oldValue) {
      const numeroCuentaInput: HTMLInputElement = this.$refs
        .numeroCuenta as HTMLInputElement;
      if (numeroCuentaInput) {
        numeroCuentaInput.value = "";
      }
      this.numeroCuenta = "";
    }
  }

  public clearUnusedFields() {
    if (!this.metodoDePagoIsTransferenciaBancaria) {
      this.banco = null;
      this.tipoDeCuenta = null;
      this.numeroCuenta = null;
      this.referenciaDocumentoBancarioFiles = [];
    }
  }

  @Watch("viaNotificacion")
  public onViaNotificacionSelected(
    newValue: CatalogoResponse,
    oldValue: CatalogoResponse
  ): void {
    if (!!oldValue) {
      this.modificaValorViaNotificacion = false;
      this.valorViaNotificacion = null;
    }
  }

  public disableStep(step: number): void {
    (
      this.sobrevivenciaWizard.$children.filter(
        (x) => x.$el.localName !== "button"
      )[step].$el as HTMLElement
    ).style.pointerEvents = "none";
  }

  public enableStep(step: number): void {
    (
      this.sobrevivenciaWizard.$children.filter(
        (x) => x.$el.localName !== "button"
      )[step].$el as HTMLElement
    ).style.pointerEvents = "auto";
  }

  public resetSecondStep(cleanTipoDocumentoSelect: boolean = true): void {
    if (cleanTipoDocumentoSelect) this.tipoDocumento = null;
    this.documentoFiles = [];
    // if (
  }

  public setPreviousFiles(): void {
    this.previousCedulaFrontalFiles = [
      this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento === this.tiposDocumentoByDocumento.tipoDocumentoCedula
      )[0],
    ];
    this.previousCedulaTraseraFiles = [
      this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento === this.tiposDocumentoByDocumento.tipoDocumentoCedula
      )[1],
    ];
    this.previousDocumentoFiles = [
      ...this.documentosCurrentPresolicitud.filter(
        (x) =>
          this.tiposDocumentoByDocumento.tipoDocumentoDocumento.includes(
            x.tipoDocumento
          ) &&
          !!x.ruta &&
          !x.esAdicional
      ),
    ];
    this.previousReferenciaDocumentoBancarioFiles = [
      ...this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento ===
          this.tiposDocumentoByDocumento
            .tipoDocumentoReferenciaDocumentoBancario
      ),
    ];
    this.previousDocumentoAdicionalFiles = [
      ...this.documentosCurrentPresolicitud.filter((x) => {
        return x.esAdicional;
      }),
    ];
    if (
      this.previousDocumentoAdicionalFiles &&
      this.previousDocumentoAdicionalFiles.length > 0
    ) {
      this.documentosAdicionales.push(
        ...this.previousDocumentoAdicionalFiles.filter(
          (x) => x.requiereCambioDoc
        )
      );
    }
  }

  public async getTiposDocumentoByStep(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      let tipoDocumentosStep1: Requisito[] = [];
      await this.cesantiaService
        .documentosRequeridos(
          String(this.formWizardSteps.firstStep.tabIndex + 1)
        )
        .then(
          (response: AxiosResponse<ServiceResponseEntities<Requisito[]>>) => {
            tipoDocumentosStep1 = response.data.entities;
          }
        );
      let tipoDocumentosStep3: Requisito[] = [];
      await this.cesantiaService
        .documentosRequeridos(
          String(this.formWizardSteps.thirdStep.tabIndex + 1)
        )
        .then(
          (response: AxiosResponse<ServiceResponseEntities<Requisito[]>>) => {
            tipoDocumentosStep3 = response.data.entities;
          }
        );
      const tipoDocumentoCedula: string =
        tipoDocumentosStep1[0].codRequisito.toString();
      const tipoDocumentoDocumento: Array<string> = this.tiposDocumento.map(
        (x) => x.codRequisito.toString()
      );
      const tipoDocumentoReferenciaDocumentoBancario: string =
        tipoDocumentosStep3[0].codRequisito.toString();
      this.tiposDocumentoByDocumento = {
        tipoDocumentoCedula,
        tipoDocumentoDocumento,
        tipoDocumentoReferenciaDocumentoBancario,
        tipoDocumentoDocumentosAdicionales: [],
      };
      resolve();
    });
  }

  public setDatosTss(presolicitud: Presolicitud): Presolicitud {
    const presolicitudClone = {
      ...presolicitud,
    };
    //
    if (this.currentPresolicitud) {
      //Si se esta editando y se hizo una validacion de certificacionTss despues de 24 horas
      //usar los nuevos valores, de lo contrario usar los valores originales
      if (this.validacionTssActualizadaDespues24hours) {
        presolicitudClone.numeroCertTSS =
          this.validacionCertificacionTss.numeroCertificacion;
        presolicitudClone.fechaCertTSS = this.validacionCertificacionTss.fecha;
        presolicitudClone.estadoCertTSS =
          this.validacionCertificacionTss.estado;
      } else {
        presolicitudClone.numeroCertTSS =
          this.currentPresolicitud.numeroCertTSS;
        presolicitudClone.fechaCertTSS = this.currentPresolicitud.fechaCertTSS;
        presolicitudClone.estadoCertTSS =
          this.currentPresolicitud.estadoCertTSS;
      }
    } else {
      if (this.validacionCertificacionTss) {
        presolicitudClone.numeroCertTSS =
          this.validacionCertificacionTss.numeroCertificacion;
        presolicitudClone.fechaCertTSS = this.validacionCertificacionTss.fecha;
        presolicitudClone.estadoCertTSS =
          this.validacionCertificacionTss.estado;
      }
    }
    return presolicitudClone;
  }

  public setFieldValues(): void {
    if (this.previousDocumentoFiles && this.previousDocumentoFiles.length > 0) {
      this.tipoDocumento = this.tiposDocumento.find(
        (x) =>
          x.codRequisito ===
          Number(this.previousDocumentoFiles[0].tipoDocumento)
      );
    }
    this.metodoDePago = this.metodosDePago.find(
      (x) => x.formaPago === this.currentPresolicitud.formaPago
    );
    this.banco = this.bancos.find(
      (x) => x.codigoBanco === String(this.currentPresolicitud.idBanco)
    );
    this.tipoDeCuenta = this.tiposDeCuenta.find(
      (x) => x.value === this.currentPresolicitud.tipoCuenta
    );
    this.numeroCuenta = this.currentPresolicitud.numeroCuenta;
    this.viaNotificacion = this.viasNotificacion.find(
      (x) => x.value === this.currentPresolicitud.viaNotificacion
    );
  }

  public moveToFifthStepAndDisableTheRest(): void {
    this.sobrevivenciaWizard.changeTab(
      this.formWizardSteps.firstStep.tabIndex,
      this.formWizardSteps.fifthStep.tabIndex
    );
    this.disableStep(this.formWizardSteps.firstStep.formWizardChildrenIndex);
    this.disableStep(this.formWizardSteps.secondStep.formWizardChildrenIndex);
    this.disableStep(this.formWizardSteps.thirdStep.formWizardChildrenIndex);
    this.disableStep(this.formWizardSteps.fourthStep.formWizardChildrenIndex);
  }

  public setCurrentStepBasedOnDocumentsThatRequireToBeChanged(
    currentStep: number
  ): void {
    if (
      this.previousCedulaFrontalRequiereCambioDoc ||
      this.previousCedulaTraseraRequiereCambioDoc
    ) {
      this.sobrevivenciaWizard.changeTab(
        currentStep,
        this.formWizardSteps.firstStep.tabIndex
      );
      currentStep = this.formWizardSteps.firstStep.tabIndex;
    } else if (
      this.previousDocumentoRequiereCambioDoc ||
      this.documentosAdicionales.length > 0
    ) {
      this.sobrevivenciaWizard.changeTab(
        currentStep,
        this.formWizardSteps.secondStep.tabIndex
      );
      currentStep = this.formWizardSteps.secondStep.tabIndex;
    } else if (this.previousReferenciaDocumentoBancarioRequiereCambioDoc) {
      this.sobrevivenciaWizard.changeTab(
        currentStep,
        this.formWizardSteps.thirdStep.tabIndex
      );
      currentStep = this.formWizardSteps.thirdStep.tabIndex;
    }
  }

  public async getPresolicitud(): Promise<Presolicitud> {
    return new Promise((resolve, reject) => {
      this.afiliadoService
        .getPresolicitud(
          new ParametrosObtencionPresolicitud(
            this.numeroSolicitud,
            this.user.cedula,
            null,
            null
          )
        )
        .then((response: AxiosResponse<ServiceResponseSolicitudes>) => {
          if (
            response.data.solicitudes &&
            response.data.solicitudes.length > 0
          ) {
            const currentPresolicitud: Presolicitud =
              response.data.solicitudes.find(
                (x) => x.numeroSolicitud == this.numeroSolicitud
              );
            resolve(currentPresolicitud || null);
          } else {
            //  this.$router.push("/solicitudes-beneficiario");
            resolve(null);
          }
        })
        .catch(() => {
          reject();
        });
    });
  }

  public async getDocumentosPresolicitud(): Promise<DocumentoPresolicitud[]> {
    this.loadingFiles = true;
    return new Promise((resolve, reject) => {
      this.afiliadoService
        .getDocumentosPresolicitud(this.numeroSolicitud)
        .then((response: AxiosResponse<ServiceResponseArchivos>) => {
          this.loadingFiles = false;
          resolve(response.data.archivos);
        })
        .catch(() => {
          this.loadingFiles = false;
          reject();
        });
    });
  }

  public showLoadingAlert(
    message: string = "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
  ): void {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });
  }

  public showLoadingConfirm(message: string, onClose: () => void = () => {}) {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      allowOutsideClick: false,
      showConfirmButton: true,
      confirmButtonText: "Ok",
      onClose,
    });
  }

  public async showErrorAlert(
    message: string,
    allowOutsideClick: boolean = true
  ): Promise<void> {
    await Swal.fire({
      text: message,
      icon: "error",
      showConfirmButton: true,
      confirmButtonText: "Ok",
      allowOutsideClick,
    });

    this.scrollToTop();
  }

  public showInfoAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
    });
  }

  get inputNumeroCuentaRules() {
    if (!this.banco) {
      return "";
    }

    if (!this.banco.validaMascara) {
      var mask = "";

      for (let i = 0; i < this.banco.lenMinimaCuenta; i++) {
        mask = mask + "9";
      }
      for (
        let i = 0;
        i < this.banco.lenMaximaCuenta - this.banco.lenMinimaCuenta;
        i++
      ) {
        mask = mask + "[9]";
      }
      this.banco.mascaraCuenta = mask;

      var mask = this.banco ? String(this.banco.mascaraCuenta) : "";
      return (
        "required|mymin-validation:" +
        String(this.banco.lenMinimaCuenta) +
        "|mymax-validation:" +
        String(this.banco.lenMaximaCuenta) +
        "|mask:" +
        String(mask)
      );
    } else {
      var mask = this.banco ? String(this.banco.mascaraCuenta) : "";
      return "required|mask:" + String(this.banco.mascaraCuenta);
    }
  }

  get currentPresolicitudEsModificable(): boolean {
    return this.currentPresolicitud && this.currentPresolicitud.esModificable;
  }

  get inputsCedulaAreValid(): boolean {
    return this.inputCedulaFrontalIsValid && this.inputCedulaTraseraIsValid;
  }

  get cedulaAfiliado(): string {
    return formatCedula(this.user.cedula);
  }

  get fechaNacimientoAfiliado(): string {
    return formatFechaAfpSiembra(this.user.fechaNacimientoDate);
  }

  get cedulaFiles(): File[] {
    return this.cedulaFrontalFiles.concat(this.cedulaTraseraFiles);
  }

  get previousCedulaFrontalRequiereCambioDoc(): boolean {
    return (
      this.previousCedulaFrontalFiles &&
      this.previousCedulaFrontalFiles.filter((x) => x.requiereCambioDoc)
        .length > 0
    );
  }

  get previousCedulaTraseraRequiereCambioDoc(): boolean {
    return (
      this.previousCedulaTraseraFiles &&
      this.previousCedulaTraseraFiles.filter((x) => x.requiereCambioDoc)
        .length > 0
    );
  }

  get previousDocumentoRequiereCambioDoc(): boolean {
    return (
      this.previousDocumentoFiles &&
      this.previousDocumentoFiles.filter((x) => x.requiereCambioDoc).length > 0
    );
  }

  get previousReferenciaDocumentoBancarioRequiereCambioDoc(): boolean {
    return (
      this.previousReferenciaDocumentoBancarioFiles &&
      this.previousReferenciaDocumentoBancarioFiles.filter(
        (x) => x.requiereCambioDoc
      ).length > 0
    );
  }

  get showCedulaFrontalInput(): boolean {
    return (
      !this.isEditing ||
      ((!this.existPreviousCedulaFrontalFiles ||
        this.previousCedulaFrontalRequiereCambioDoc ||
        this.previousCedulaTraseraRequiereCambioDoc) &&
        !this.loadingFiles)
    );
  }

  get showCedulaTraseraInput(): boolean {
    return (
      !this.isEditing ||
      ((!this.existPreviousCedulaTraseraFiles ||
        this.previousCedulaTraseraRequiereCambioDoc ||
        this.previousCedulaFrontalRequiereCambioDoc) &&
        !this.loadingFiles)
    );
  }

  public documentosAdicionalesAreValid(): boolean {
    return (
      !this.documentosAdicionales ||
      this.documentosAdicionales.length === 0 ||
      (this.documentosAdicionales &&
        this.documentosAdicionales.length > 0 &&
        this.documentosAdicionales.every(
          (documentoAdicional: Presolicitud, index: number) => {
            var documentoAdicionalTieneArchivo =
              !!this.documentoAdicionalFiles[index] &&
              this.documentoAdicionalFiles[index].length > 0;
            //
            if (!documentoAdicionalTieneArchivo) {
              this.showDocumentoAdicionalFilesRequiredError[index] = true;
              this.$forceUpdate();
              return false;
            }

            if (this.showInvalidDocumentoAdicionalFilesTypeError[index])
              return !this.showInvalidDocumentoAdicionalFilesTypeError[index];

            if (this.showInvalidDocumentoAdicionalFilesSizeError[index])
              return !this.showInvalidDocumentoAdicionalFilesSizeError[index];

            return true;
          }
        ))
    );
  }

  public fileRemoveConfirmAlert(
    fileName: string
  ): Promise<SweetAlertResult<boolean>> {
    return Swal.fire({
      text: "¿Deseas eliminar el archivo " + fileName + " ?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ED8B2F",
      cancelButtonColor: "#0F6CBC",
      confirmButtonText: "OK",
      reverseButtons: true,
    });
  }

  public onRemoveCedulaFrontalFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeCedulaFrontalFile(archivoPresolicitud);
          this.removeCedulaTraseraFile(this.previousCedulaTraseraFiles[0]);
        }
      }
    );
  }

  public removeCedulaFrontalFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number =
      this.previousCedulaFrontalFiles.indexOf(archivoPresolicitud);
    this.previousCedulaFrontalFiles.splice(index, 1);
    this.removedFiles.push(archivoPresolicitud);
  }

  public onRemoveCedulaTraseraFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeCedulaTraseraFile(archivoPresolicitud);
          this.removeCedulaFrontalFile(this.previousCedulaFrontalFiles[0]);
        }
      }
    );
  }
  public handleTabChange({ tabIndex }: { tabIndex: number }): void {
    // Solo haces scroll si NO lo estás haciendo desde botones personalizados
    if (!this.scrollHandledManually) {
      this.scrollToTop();
    }

    // Reiniciar bandera para próximos tabs
    this.scrollHandledManually = false;
  }

  public removeCedulaTraseraFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number =
      this.previousCedulaTraseraFiles.indexOf(archivoPresolicitud);
    if (index > -1) {
      this.previousCedulaTraseraFiles.splice(index, 1);
      this.removedFiles.push(archivoPresolicitud);
    }
  }

  public removeDocumentoFile(
    documentoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousDocumentoFiles.indexOf(
      documentoPresolicitud
    );
    this.previousDocumentoFiles.splice(index, 1);
    this.removedFiles.push(documentoPresolicitud);
  }

  public removeReferenciaDocumentoBancarioFile(
    documentoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousReferenciaDocumentoBancarioFiles.indexOf(
      documentoPresolicitud
    );
    this.previousReferenciaDocumentoBancarioFiles.splice(index, 1);
    this.removedFiles.push(documentoPresolicitud);
  }

  public removeDocumentoAdicionalFile(
    documentoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousDocumentoAdicionalFiles.indexOf(
      documentoPresolicitud
    );
    this.previousDocumentoAdicionalFiles.splice(index, 1);
    this.removedFiles.push(documentoPresolicitud);
  }

  public onRemoveDocumentoFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeDocumentoFile(archivoPresolicitud);
        }
      }
    );
  }

  public onRemoveReferenciaDocumentoBancarioFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeReferenciaDocumentoBancarioFile(archivoPresolicitud);
        }
      }
    );
  }

  public onRemoveDocumentoAdicionalFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeDocumentoAdicionalFile(archivoPresolicitud);
          //this.documentosAdicionales.push(archivoPresolicitud);
        }
      }
    );
  }

  public getFileName(fileUrl: string): string {
    if (fileUrl.includes("/")) {
      const fileName = fileUrl.split("/");
      return fileName[fileName.length - 1];
    } else {
      return fileUrl;
    }
  }

  public onAddOrRemoveCedulaFrontalFile(files: Array<File>): void {
    this.disableStep(this.formWizardSteps.secondStep.formWizardChildrenIndex);
    const sanitizedFiles = files.map((file) => {
      const cleanName = sanitizeFileName(file.name);
      return new File([file], cleanName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    });
    this.cedulaFrontalFiles = sanitizedFiles;
    this.cedulaIsValid = false;
    this.cedulaFrontalServerMessage = "";
  }

  public cedulaFrontalValidationChanged(isValid: boolean): void {
    this.inputCedulaFrontalIsValid = isValid;
  }

  public onAddOrRemoveCedulaTraseraFile(files: Array<File>): void {
    this.disableStep(this.formWizardSteps.secondStep.formWizardChildrenIndex);
    const sanitizedFiles = files.map((file) => {
      const cleanName = sanitizeFileName(file.name);
      return new File([file], cleanName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    });
    this.cedulaTraseraFiles = sanitizedFiles;
    this.cedulaIsValid = false;
    this.cedulaTraseraServerMessage = "";
  }

  public cedulaTraseraValidationChanged(isValid: boolean): void {
    this.inputCedulaTraseraIsValid = isValid;
  }

  public onAddOrRemoveDocumentoFile(files: Array<File>): void {
    const sanitizedFiles = files.map((file) => {
      const cleanName = sanitizeFileName(file.name);
      return new File([file], cleanName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    });

    this.documentoFiles = sanitizedFiles;
    this.documentoIsValid = false;
    this.documentoServerMessage = "";
  }

  public documentoValidationChanged(isValid: boolean): void {
    this.documentoIsValid = isValid;
  }

  public referenciaDocumentoBancarioValidationChanged(isValid: boolean): void {
    this.inputReferenciaDocumentoBancarioIsValid = isValid;
  }

  public onAddOrRemoveReferenciaDocumentoBancarioFile(
    files: Array<File>
  ): void {
    const sanitizedFiles = files.map((file) => {
      const cleanName = sanitizeFileName(file.name);
      return new File([file], cleanName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    });
    this.referenciaDocumentoBancarioFiles = sanitizedFiles;
    this.inputReferenciaDocumentoBancarioIsValid = false;
    this.referenciaDocumentoBancarioServerValidationMessage = "";
  }

  public onAddOrRemoveDocumentoAdicionalFile(
    index: number,
    tipoDocumento: string
  ): void {
    let pond: any = this.$refs["documentoAdicional" + index][0];
    const files = pond.getFiles().map((x) => {
      const file = x.file;
      const cleanName = sanitizeFileName(file.name);
      return new File([file], cleanName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    });
    this.documentoAdicionalFiles[index] = files;
    const tiposDocumento: Array<string> = this.documentoAdicionalFiles[
      index
    ].map(() => {
      return tipoDocumento;
    });
    this.tiposDocumentoByDocumento.tipoDocumentoDocumentosAdicionales[index] =
      tiposDocumento;
    //
    this.showDocumentoAdicionalFilesRequiredError[index] =
      this.documentoAdicionalFiles[index].length === 0;
    if (this.showDocumentoAdicionalFilesRequiredError[index]) {
      this.disableStep(this.formWizardSteps.thirdStep.formWizardChildrenIndex);
    }
    const anyFileTypeInvalid: boolean = this.documentoAdicionalFiles[
      index
    ].some((x) => !this.fileConfig.allowedFileTypes.includes(x.type));
    this.showInvalidDocumentoAdicionalFilesTypeError[index] =
      anyFileTypeInvalid;
    const anyFileSizeInvalid: boolean = this.documentoAdicionalFiles[
      index
    ].some((x) => x.size / 1000000 > this.fileConfig.fileSizeMbLimit);
    this.showInvalidDocumentoAdicionalFilesSizeError[index] =
      anyFileSizeInvalid;
    this.$forceUpdate();
  }

  public async getTiposDocumento() {
    this.tiposDocumentoLoading = true;
    const response = await this.cesantiaService.documentosRequeridos(
      String(this.formWizardSteps.secondStep.tabIndex + 1)
    );
    if (response.data.entities) {
      this.tiposDocumento = response.data.entities;
    } else {
      this.tiposDocumento = [];
    }
    this.tiposDocumentoLoading = false;
  }

  public async getViasNotificacion(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.viasNotificacionLoading = true;
    const response = await this.afiliadoService.viasNotificacion(term);
    if (response.data.entity) {
      this.viasNotificacion = response.data.entity;
    } else {
      this.viasNotificacion = [];
    }
    this.viasNotificacionLoading = false;
  }

  public async getBancos(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.bancosLoading = true;
    const response = await this.afiliadoService.bancos(term);
    if (response.data.entities) {
      this.bancos = response.data.entities;
    } else {
      this.bancos = [];
    }
    this.bancosLoading = false;
  }

  public async getMetodosDePago(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.metodosDePagoLoading = true;
    const response = await this.afiliadoService.metodosDePago(
      this.user.monSalarioRetiro,
      term
    );
    if (response.data.entities) {
      this.metodosDePago = response.data.entities.filter(
        (x) =>
          x.topeMinimo <= this.user.monSalarioRetiro &&
          x.topeMaximo >= this.user.monSalarioRetiro
      );
    } else {
      this.metodosDePago = [];
    }
    this.metodosDePagoLoading = false;
  }

  public async getTiposDeCuenta(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.tiposDeCuentaLoading = true;
    const response = await this.afiliadoService.tiposDeCuenta(term);
    if (response.data.entity) {
      this.tiposDeCuenta = response.data.entity;
    } else {
      this.tiposDeCuenta = [];
    }
    this.tiposDeCuentaLoading = false;
  }

  public firstStepIsValid(): boolean {
    if (!this.currentPresolicitudEsModificable) {
      return true;
    }
    if (this.previousCedulaFrontalRequiereCambioDoc) {
      if (!this.inputCedulaFrontalIsValid) {
        return false;
      }
    }
    if (this.previousCedulaTraseraRequiereCambioDoc) {
      if (!this.inputCedulaTraseraIsValid) {
        return false;
      }
    }
    return (
      (this.inputsCedulaAreValid && this.cedulaIsValid) ||
      this.existPreviousCedulaFiles
    );
  }

  public secondStepIsValid(): boolean {
    if (!this.currentPresolicitudEsModificable) {
      return true;
    }
    if (this.datosCedulaCoincideConBD) {
      return true;
    }
    if (this.existPreviousDocumentoFiles) {
      if (this.previousDocumentoRequiereCambioDoc) {
        if (!this.documentoIsValid) {
          return false;
        }
      } else {
        return true;
      }
    }
    if (this.omitirActualizacionDatos) {
      return true;
    }
    return this.documentoIsValid;
  }

  public thirdStepIsValid(): boolean {
    if (!this.currentPresolicitudEsModificable) {
      return true;
    }
    if (this.previousReferenciaDocumentoBancarioRequiereCambioDoc) {
      if (!this.existReferenciaDocumentoBancarioFiles) {
        return false;
      }
    }
    return !!this.numeroSolicitudCreada;
  }

  get metodoDePagoIsTransferenciaBancaria(): boolean {
    return this.metodoDePago && this.metodoDePago.formaPago === "T";
  }

  get existReferenciaDocumentoBancarioFiles(): boolean {
    return (
      this.referenciaDocumentoBancarioFiles &&
      this.referenciaDocumentoBancarioFiles.length > 0
    );
  }

  get existPreviousCedulaFrontalFiles(): boolean {
    return !(
      this.previousCedulaFrontalFiles &&
      this.previousCedulaFrontalFiles.length === 0
    );
  }

  get existPreviousCedulaTraseraFiles(): boolean {
    return !(
      this.previousCedulaTraseraFiles &&
      this.previousCedulaTraseraFiles.length === 0
    );
  }

  get existPreviousCedulaFiles(): boolean {
    return (
      this.existPreviousCedulaFrontalFiles &&
      this.existPreviousCedulaTraseraFiles
    );
  }

  get existPreviousDocumentoFiles(): boolean {
    return !(
      this.previousDocumentoFiles && this.previousDocumentoFiles.length === 0
    );
  }

  get existPreviousReferenciaDocumentoBancarioFiles(): boolean {
    return !(
      this.previousReferenciaDocumentoBancarioFiles &&
      this.previousReferenciaDocumentoBancarioFiles.length === 0
    );
  }

  get existPreviousDocumentoAdicionalFiles(): boolean {
    return !(
      this.previousDocumentoAdicionalFiles &&
      this.previousDocumentoAdicionalFiles.length === 0
    );
  }

  get generaSolicitudAutomatica(): boolean {
    return (
      !this.metodoDePagoIsTransferenciaBancaria && this.datosCedulaCoincideConBD
    );
  }

  public nextAction(
    success: boolean,
    nextAction: (props: any, _this: RegistroSobrevivencia) => any,
    props: any
  ): void {
    if (success) {
      if (nextAction) {
        nextAction(props, this);
      }
    }
  }

  public async verificarCedula(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (!this.existPreviousCedulaFiles && !this.inputsCedulaAreValid) {
        this.callInputValidation();
        resolve(this.cedulaIsValid);
        return;
      }
      if (
        (this.previousCedulaFrontalRequiereCambioDoc &&
          !this.inputCedulaFrontalIsValid) ||
        (this.previousCedulaTraseraRequiereCambioDoc &&
          !this.inputCedulaTraseraIsValid)
      ) {
        this.callInputValidation();
        resolve(this.cedulaIsValid);
        return;
      }
      if (
        !this.existPreviousCedulaFiles ||
        this.previousCedulaFrontalRequiereCambioDoc ||
        this.previousCedulaTraseraRequiereCambioDoc
      ) {
        this.cedulaFrontalServerMessage = "";
        this.cedulaTraseraServerMessage = "";
        this.showLoadingAlert(
          "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
        );
        this.loading = true;
        this.validationService
          .validateCedulaAfiliadoIT(
            new ValidacionCedulaIt(
              this.user.cedula,
              this.user.getNombreCompleto(),
              this.user.fechaNacimientoDate,
              this.previousCedulaFrontalFiles &&
              this.previousCedulaFrontalFiles.length > 0
                ? this.previousCedulaFrontalFiles[0].ruta
                : null,
              this.previousCedulaTraseraFiles &&
              this.previousCedulaTraseraFiles.length > 0
                ? this.previousCedulaTraseraFiles[0].ruta
                : null
            ),
            {
              cedulaFrontal: this.cedulaFrontalFiles,
              cedulaTrasera: this.cedulaTraseraFiles,
            }
          )
          .then(
            (
              response: AxiosResponse<
                ServiceResponseEntity<ValidacionCedulaItResp>
              >
            ) => {
              if (response.data.respCode == 200) {
                this.datosCedulaCoincideConBD = true;
                this.resultValidacionCedula = response.data.entity;
                this.cedulaIsValid = true;
              } else {
                switch (response.data.respCode) {
                  case 410:
                    // Nombre afiliado no coincide
                    this.datosCedulaCoincideConBD = false;
                    this.resultValidacionCedula = response.data.entity;
                    if (this.resultValidacionCedula.cedulaCoincide) {
                      this.cedulaIsValid = true;
                    }
                    break;
                  case 411:
                    // Cedula frontal de baja calidad
                    this.cedulaFrontalServerMessage = response.data.message;
                    break;
                  case 412:
                    // Cedula trasera de baja calidad
                    this.cedulaTraseraServerMessage = response.data.message;
                    break;
                  default:
                    this.loading = false;
                    this.showErrorAlert(
                      "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                      true
                    );
                    resolve(false);
                    return;
                }

                //Each time cedula validation run, update currentPresolicitud values
                if (this.currentPresolicitud) {
                  this.currentPresolicitud.cedulaCoincide =
                    this.resultValidacionCedula.cedulaCoincide;
                  this.currentPresolicitud.nombreCoincide =
                    this.resultValidacionCedula.nombreCoincide;
                  this.currentPresolicitud.fechaNacimientoCoincide =
                    this.resultValidacionCedula.fechaNacimientoCoincide;
                }
              }
              this.loading = false;
              Swal.close();
              resolve(this.cedulaIsValid);
              if (!this.resultValidacionCedula.cedulaCoincide) {
                Swal.fire({
                  text: "El número de cédula de identidad del documento que cargó no coincide con el número de cédula registrado en nuestra base de datos. Ambos números deben coincidir para que puedas continuar con el registro de su solicitud.",
                  icon: "warning",
                  confirmButtonText: "OK",
                });
              }
            }
          )
          .catch(() => {
            this.loading = false;
            Swal.close();
            reject();
          });
      } else {
        this.loading = false;
        Swal.close();
        resolve(true);
      }
    });
  }

  public async saveBeneficiarios() {
    this.sobrevivenciaService.SaveBeneficiarios(
      "PortalBe",
      "0092873730",
      this.benefactors
    );

    // Swal.fire({ title: "Los beneficiarios han sido guardados", toast: true });

    return true;
  }

  public async saveCurrentBenefactor() {
    this.sobrevivenciaService.SaveBeneficiarios("PortalBe", "0092873730", [
      this.currentBenefactor,
    ]);

    // Swal.fire({ title: "Los beneficiarios han sido guardados", toast: true });

    return true;
  }
  public async returnTrue(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      resolve(true);
      return;
    });
  }
  public async invalidarSolicitud(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.showLoadingConfirm(
        "Lo sentimos, actualmente no cumples con los requisitos para continuar con esta solicitud de beneficios. Esta será anulada.",
        () => {
          const registroPresolicitud = new RegistroPresolicitud();
          registroPresolicitud.presolicitud.tipoBeneficio =
            TipoBeneficioEnum.Cesantia.toString();
          registroPresolicitud.presolicitud.numeroSolicitud =
            this.numeroSolicitud;
          registroPresolicitud.presolicitud.cedulaAfiliado = this.user.cedula;
          registroPresolicitud.presolicitud.cedulaBeneficiario =
            this.user.cedula;
          registroPresolicitud.presolicitud.estado = "C";
          this.afiliadoService
            .registroPresolicitud(registroPresolicitud, {
              cedula: null,
              docsActDatos: null,
              referenciaDocumentoBancario: null,
              documentosAdicionales: null,
            })
            .then((response: AxiosResponse<ServiceResponseSolicitud>) => {
              if (response.data.respCode === 200) {
                Swal.close();
                this.$router.push("/home");
                resolve();
              } else {
                this.showErrorAlert(
                  response.data.message ||
                    "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                  false
                );
                resolve();
              }
            })
            .catch((error) => {
              this.showErrorAlert(
                "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                false
              );
              reject();
            });
        }
      );
    });
  }

  public isDocumentationValid() {
    // let approved = true;

    // for (const doc of this.generalDocs) {
    //   const invalid = this.validacionesDocumento(doc);

    //   if (doc.estRecepDoc !== PossibleStates.Aprobado) approved = false;

    //   if (invalid) return invalid;
    // }
    // for (const benefactor of this.benefactors) {
    //   for (const doc of benefactor.documents) {
    //     const invalid = this.validacionesDocumento(doc);

    //     if (doc.estRecepDoc !== PossibleStates.Aprobado) approved = false;

    //     if (invalid) return invalid;
    //   }
    // }

    let generalPending = false;
    let generalRejected = false;
    let generalAproved = false;
    let benefactorsPending = false;
    let benefactorsRejected = false;
    let beneractorsAproved = true;
    ///existen archivos generales pendientes?
    generalPending = this.generalDocs.some(
      (doc) => doc.estado == PossibleStates.Pendiente
    );
    generalRejected = this.generalDocs.some(
      (doc) => doc.estado == PossibleStates.Rechazado
    );
    generalAproved = this.generalDocs.some(
      (doc) => doc.estado !== PossibleStates.Aprobado
    );
    //documentos de beneficiarios
    // console.log("this.BENEFACTORS")
    // console.log(this.benefactors)
    this.benefactors = this.benefactors.filter((benefactor) => {
      return benefactor !== undefined;
    });
    //  if(this.benefactors){
    //   for (const benefactor of this.benefactors) {
    //   for (const doc of benefactor.documents) {
    //     if (doc.estado == PossibleStates.Rechazado){
    //       benefactorsRejected = true;
    //     }
    //     if (doc.estado == PossibleStates.Pendiente){
    //       benefactorsPending = true;
    //     }
    //     if ( doc.estado !== PossibleStates.Aprobado){
    //       beneractorsAproved = false;
    //     }
    //   }
    // }
    //  }
    this.benefactors.forEach((benefactor: Benefactor) => {
      if (benefactor.documents) {
        for (const doc of benefactor.documents) {
          if (doc.estado == PossibleStates.Rechazado) {
            benefactorsRejected = true;
          }
          if (doc.estado == PossibleStates.Pendiente) {
            benefactorsPending = true;
          }
          if (doc.estado !== PossibleStates.Aprobado) {
            beneractorsAproved = false;
          }
        }
      }
    });

    return {
      missingFiles: this.isAnyDocPending,
      rejectedFiles: generalRejected || benefactorsRejected,
      approved: !generalAproved && beneractorsAproved,
    };
  }

  public validacionesDocumento(doc: BenefactorDocument) {
    if (doc.estRecepDoc == PossibleStates.Rechazado) {
      return { missingFiles: false, rejectedFiles: true, approved: false };
    }

    if (
      (!doc.files || doc.files.length == 0) &&
      !doc.link &&
      doc.indRequiereValidacion == "S"
    ) {
      return { missingFiles: true, rejectedFiles: false, approved: false };
    }

    return undefined;
  }

  public async navigateToSolicitudes(): Promise<boolean> {
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
    return new Promise((resolve, reject) => {
      this.$router.push("/solicitudes-beneficiario");
      resolve(true);
    });
  }

  public showSuccessAlert(message: string = "") {
    Swal.fire({
      html: message.length > 0 ? message : "Datos guardados satisfactoriamente",
      showConfirmButton: false,
      icon: "success",
      timer: 3000,
    });
  }
  /////////////New methods
  registerFirstStep() {
    this.triggerRegisterFirstStep = !this.triggerRegisterFirstStep;
  }

  getFormularioResponses() {
    this.triggerGeneralFormularioCollection =
      !this.triggerGeneralFormularioCollection;
    this.triggerBeneficiarioFormularioCollection =
      !this.triggerBeneficiarioFormularioCollection;

    this.scrollToTop();
  }
  getGeneralFormularioResponses() {
    this.triggerGeneralFormularioCollection =
      !this.triggerGeneralFormularioCollection;

    this.scrollToTop();
  }
  getBeneficiarioFormularioResponses() {
    this.triggerBeneficiarioFormularioCollection =
      !this.triggerBeneficiarioFormularioCollection;
  }

  public async colletResponses(value: SaveFormularioRequest) {
    if (this.numeroSolicitud == null) {
      this.numeroSolicitud = Number(this.$route.query.numeroSolicitud);
    }
    Swal.fire({
      title: "Guardando información...",
      text: "Este proceso puede tardar unos segundos.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    this.showLoadingAlert(
      "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
    );
    // console.log("numero presolicitud collet resposne",this.numeroSolicitud)
    value.numPreSolicitud = this.numeroSolicitud;
    value.canal = "PortalBe";
    value.codUsuario = this.user.cedula;
    this.loadingPage = true;
    const resp = await this.sobrevivenciaService.saveFormulario(value);
    Swal.close();
    if (resp.data.code == 200) {
      if (this.numeroSolicitud == null) {
        this.numeroSolicitud = Number(this.$route.query.numeroSolicitud);
      }

      //  PromiseAll aqui
      // await this.getBeneficiarios();
      // await this.getDocumentosGenerales();
      await Promise.all([
        this.getBeneficiarios(),
        this.getDocumentosGenerales(),
      ]);
      await this.getDocumentosBeneficiarios();

      this.beneficiarioFormKey = Math.floor(
        Math.random() * (9999 - 999 + 1) + 999
      );
      // console.log("beneficiario key formateado");
      this.generalFormKey = Math.floor(Math.random() * (99 - 9 + 1) + 9);

      setTimeout(() => {
        this.loadingPage = false;
      }, 2500);
    } else {
      this.showErrorAlert(
        "Ha ocurrido un error en la comunicación.Por favor intentar más tarde."
      );
      this.beneficiarioFormKey = Math.floor(
        Math.random() * (9999 - 999 + 1) + 999
      );
      this.generalFormKey = Math.floor(Math.random() * (99 - 9 + 1) + 9);
      setTimeout(() => {
        this.loadingPage = false;
      }, 2500);
      this.loadingPage = false;
    }
  }

  public changeWizardTab(from: number, to: number) {
    this.sobrevivenciaWizard.changeTab(from, to);
    if (to == 1) {
      this.disableStep(this.formWizardSteps.firstStep.formWizardChildrenIndex);
    }
  }
  public async setEtapa(etapa: number) {
    let request: EtapaRequest = new EtapaRequest();
    (request.numPreSolicitud = this.numeroSolicitud),
      (request.codEtapa = etapa);
    request.codUsuario = this.cedulaAfiliado;
    this.sobrevivenciaService
      .setEtapa(request)
      .then((response) => {
        // console.log(response);
        this.changeWizardTab(0, etapa);
      })
      .catch((error) => {
        console.log("F updating etapa");
      });
  }

  public changeWizardTabFromEtapa() {
    if (this.etapa !== null) {
      if (this.etapa == 3) {
        const validations = this.isDocumentationValid();
        if (validations.rejectedFiles) {
          this.disableStep(8);
          return this.sobrevivenciaWizard.changeTab(0, 2);
        }
        if (validations.approved) {
          this.isValidationValid = true;
        } else {
          this.isValidationValid = false;
        }
      }
      if (
        this.etapa >= 5 &&
        this.currentBenefactor != null &&
        this.currentBenefactor.codEtapa != null
      ) {
        this.etapa = this.currentBenefactor.codEtapa;
      }

      for (let i = 0; i < this.etapa; i++) {
        // console.log("des steps")
        this.sobrevivenciaWizard.changeTab(i, i + 1);
        this.disableStep(i + 8);
      }

      if (this.etapa > 1) {
        this.disableStep(
          this.formWizardSteps.firstStep.formWizardChildrenIndex
        );
        this.disableStep(
          this.formWizardSteps.secondStep.formWizardChildrenIndex
        );
      }
    }
  }

  public async getEtapaSolicitud() {
    if (this.numeroSolicitud !== null) {
      let request = new BaseSobrevivenciaRequest(
        "PortalBe",
        this.user.cedula,
        this.numeroSolicitud
      );
      await this.sobrevivenciaService
        .getSobrevivenciPresolicitud(request)
        .then((response) => {
          this.etapa = response.data.data.codEtapa;
        })
        .catch((error) => {
          console.log("error" + error);
        });
    }
  }

  public async openBeneficiario(value: number) {
    // console.log("Registro Sobrevivencia recibe para abrir:" + value);
    this.openBeneficiarioId = value;
    this.showBeneficiariosInnerTab = true;
    this.sobrevivenciaWizard.changeTab(2, 1);
  }
  public async isAnyDocPendingChangedHandler(value: boolean) {
    // alert("estado updated 1:"+value)
    this.isAnyDocPending = value;
  }

  async ValidateFormBeneficiarios(): Promise<boolean> {
    const isValid = await (
      this.$refs.FormularioBeneficiarioObserver as VeeValidateForm
    ).validate();
    // console.log("Validación Formulario Beneficiarios :" + isValid);
    return isValid;
  }

  async ValidateFormGeneral(): Promise<boolean> {
    const isValid = await (
      this.$refs.FormularioGeneralObserver as VeeValidateForm
    ).validate();
    // console.log("Validación Formulario GENERAL :" + isValid);

    return isValid;
  }

  async ValidateMetodoPago(): Promise<boolean> {
    const isValid = await (
      this.$refs.MetodoPagoObserver as VeeValidateForm
    ).validate();
    // console.log("Validación metodo de pago :" + isValid);

    return isValid;
  }

  public async firmarContratoFallecimiento(): Promise<boolean> {
    this.showLoadingAlert(
      "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
    );
    return new Promise((resolve, reject) => {
      let request: BaseSobrevivenciaRequest = new BaseSobrevivenciaRequest(
        "PortalBe",
        this.user.cedula,
        this.numeroSolicitud
      );
      this.sobrevivenciaService
        .firmarContratoFallecimiento(request)
        .then((response) => {
          window.removeEventListener("beforeunload", this.beforeUnloadHandler);
          location.href = response.data.signingUrl;
          resolve(true);
          Swal.close();
        })
        .catch((error) => {
          console.log("error on Firmar");
          console.log(error);
          Swal.close();
          reject();
        });
    });
  }

  public async firmarDescargoFallecimiento(): Promise<boolean> {
    this.showLoadingAlert(
      "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
    );
    return new Promise((resolve, reject) => {
      var request: FirmaDescargoRequest = new BaseSobrevivenciaRequest(
        "PortalBe",
        this.user.cedula,
        this.numeroSolicitud
      );
      request.codBeneficiario = this.currentBenefactor.idBeneficiario;
      this.sobrevivenciaService
        .firmarDescargoFallecimiento(request)
        .then((response) => {
          window.removeEventListener("beforeunload", this.beforeUnloadHandler);
          location.href = response.data.signingUrl;
          resolve(true);
          Swal.close();
        })
        .catch((error) => {
          console.log("error on Firmar");
          console.log(error);
          Swal.close();
          reject();
        });
    });
  }

  public handleNoLoggedUser() {
    try {
      if (this.$route.query.params) {
        let params = this.$route.query.params.toString();
        params = params.replace(/\s/g, "+");
        let decypt = this.afiliadoService.decryptByDES(params);

        let noLoggedUser: NoLoggedUser = JSON.parse(decypt);
        this.user.cedula = noLoggedUser.benefPrincipal;
        this.numeroSolicitud = noLoggedUser.numPreSolicitud;
        this.$store.dispatch("setNoLoggedUser", noLoggedUser);
      }
    } catch (e) {
      console.log("error ", e);
      //  alert("eror ocn json")
      this.$router.push("/home");
    }

    // if (this.$route.query.principal) {
    //   this.user.cedula = this.$route.query.principal.toString();
    // }
  }
  get currentBeneficiarioCedula() {
    if (this.$route.query.beneficiario) {
      return this.$route.query.beneficiario.toString();
    }
    return this.user.cedula;
  }

  @Watch("benefactors")
  public benefactorsChanged(newValue, oldValue) {
    let benefactor: Benefactor;
    if (this.noLoggedUser != null && this.noLoggedUser.beneficiario != null) {
      if (this.benefactors) {
        benefactor = this.benefactors.find(
          (benefactor) =>
            benefactor.idBeneficiario == this.noLoggedUser.beneficiario
        );
        benefactor.cedulaBenefPrincipal = this.noLoggedUser.benefPrincipal;
      }
    } else {
      if (this.benefactors && this.benefactors.length > 0) {
        benefactor = this.benefactors.find(
          (benefactor) => benefactor.esBenefPrincipal == "S"
        );
        benefactor.esBenefPrincipal = "S";
        benefactor.cedulaBenefPrincipal = benefactor.numIdBeneficiario;
      }
    }

    this.$store.dispatch("setCurrentBenefactor", benefactor);
  }

  @Watch("noLoggedUser")
  public setNoLoggedUser(newValue: NoLoggedUser, old: NoLoggedUser) {
    this.noLoggedUser = newValue;
  }

  @Watch("currentBenefactor")
  public watchBenefactor(newValue: Benefactor) {
    if (newValue.indFirma != null && newValue.indFirma == "S") {
      this.$router.push(
        "/resumen-sobrevivencia?numeroSolicitud=" + this.numeroSolicitud
      );
    }
  }
  get cartaAseguradoraUrl() {
    const found = this.generalDocs.filter(
      (x) => Number(x.codTipDocumento) == 209
    );
    if (found && found.length > 0) {
      return found[0].link;
    } else {
      return null;
    }
  }
  public scrollToTop(): void {
    this.$nextTick(() => {
      setTimeout(() => {
        const element = document.getElementById("InicioTop");
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        } else {
          console.warn("Elemento #InicioTop no encontrado.");
        }
      }, 200); // Dale unos ms al render si hay animaciones o tabs
    });
  }

  public async validatePendingPresolicitud() {
    // Para validar si existen solicitudes en curso. Se permite subir acta de nacimiento.
    // console.log("A1")
    if (this.currentPresolicitud == null) {
      await this.getPresolicitud();
    }
    let cedulaAfiliadoFallecido =
      this.currentPresolicitud != null &&
      this.currentPresolicitud.cedulaAfiliado != null
        ? this.currentPresolicitud.cedulaAfiliado
        : this.cedulaFallecido;

    let consultaFallecido = new ConsultaFallecido();
    (consultaFallecido.cedulaBeneficiario = this.user.cedula),
      (consultaFallecido.cedulaFallecido = cedulaAfiliadoFallecido);
    let resultPreviosPreSolicitud =
      this.afiliadoService.getExistPreviosPreSolicitud(consultaFallecido);
    // console.log("A2")

    resultPreviosPreSolicitud.then((result) => {
      if (
        result.data.existPreoviousPreSolicitud == true &&
        this.numeroSolicitud != result.data.numPreSolicitud
      ) {
        this.disableStep(
          this.formWizardSteps.firstStep.formWizardChildrenIndex
        );
        this.disableStep(
          this.formWizardSteps.secondStep.formWizardChildrenIndex
        );
        this.disableStep(
          this.formWizardSteps.thirdStep.formWizardChildrenIndex
        );
        this.disableStep(
          this.formWizardSteps.fifthStep.formWizardChildrenIndex
        );
        this.disableStep(
          this.formWizardSteps.sixthStep.formWizardChildrenIndex
        );
        this.changeWizardTab(0, 3);
      }
    });
  }

  public afterFirstStepCompleted() {
    this.loading = true;
    this.setEtapa(1);
    // console.log("after first step");
    this.validatePendingPresolicitud();
    // console.log("after first step termina")
    this.loading = false;
  }

  @Watch("$route.query.numeroSolicitud")
  public watchNumSolicitud() {
    this.numeroSolicitud = Number(this.$route.query.numeroSolicitud);
  }
}
